import { MenuItem, Checkbox } from "@material-ui/core";
import CustomizedDialogs from "../../customModal";
import { Input } from "../../../forms/input";
import React, { useState, useEffect, useReducer } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Termsandconditions } from "./lib/Termsandconditions";
import {
  getNewPurchaseFundList,
  validateSubBroker,
  submitLumpsumDetails,
  clearingFirstTimeInvestorJourney,
  storeSchemeDetails,
  PurchaseSaveNominee
} from "../../../../store/actions";
import {
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILED,
  REGULAR,
} from "../../../../store/types";
import IntegrationReactSelect from "../../../forms/autoCompleteInput";
import { RadioButton } from "./lib/Radiobutton";
import CustomLoader from "../../../forms/Loader";
import { format, set } from "date-fns";
import CustomizedSelect from "../customizedSelect";
import CardComponent from "./lib/CardComponent";
import { use } from "react";
const Lumpsum = (props) => {
  const initialState = {
    Scheme: { value: "" },
    Category: { value: "" },
    "Scheme Plan": "",
    "Scheme Option": "",
    Amount: { value: "" },
    "Sub Broker Code": { value: "" },
    "Sub ARN Code": { value: "" },
    planValue: "",
    optionValue: "",
    schemeValue: "",
    EUIN: "",
    schemeList: [],
    euinList: [],
    CategoryList: [],
    multiples: "",
  };
  const [formValues, setFormValues] = useReducer(
    (preValues, newValues) => ({ ...preValues, ...newValues }),
    initialState
  );
  const InputFields = [
    [
      {
        name: "Category",
        type: "select",
        placeholder: "Select Category",
        isMandatory: true,
        listName: "CategoryList",
      },

      {
        name: "Scheme",
        type: "Searchselect",
        placeholder: "Select Scheme",
        isMandatory: true,
        listName: "schemeList",
      },
      {
        name: "Scheme Plan",
        type: "text",
        placeholder: "Select Scheme Plan",
        isMandatory: true,
        listName: "schemePlanList",
        disabled: true,
        display: "none",
      },
    ],
    [
      {
        name: "Scheme Option",
        type: "text",
        placeholder: "Select Scheme Option",
        isMandatory: true,
        listName: "schemeOptionList",
        disabled: true,
        display: "none",
      },
      {
        name: "Sub ARN Code",
        type: "number",
        placeholder: "Select ARN Code",
        isMandatory: false,
      },
      {
        name: "Sub Broker Code",
        type: "number",
        placeholder: "Select Sub Broker Code",
        isMandatory: false,
      },
      {
        name: "EUIN",
        type: "Searchselect",
        placeholder: "Select EUIN",
        isMandatory: true,
        listName: "euinList",
      },
    ],
    [
      {
        name: "Amount",
        type: "number",
        placeholder: "Enter Amount",
        isMandatory: true,
      },
    ],

  ];
  const [dialog, setDialog] = useState({ open: false, appno: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const history = useHistory();
  const fetchSchemeList = async () => {
    try {
      const params = {
        plntype: "Regular",
        opt: "S",
        schemetype: formValues.Category.value,
        fund: "189"
      };
      const response = await props.getNewPurchaseFundList(params);
      const { Dtinformation } = response;
      const schemeList = Dtinformation.map((item) => ({
        value: item.Scheme_Plan,
        label: item.Scheme_Desc,
        plan: item.PlanDesc,
        option: item.fm_optiondesc,
        planValue: item.Scheme_Plan.split("~")[2],
        optionValue: item.Scheme_Plan.split("~")[3],
        schemeValue: item.Scheme_Plan.split("~")[1],
        minAmt: item.MinAmt,
        multiples: item.multiples,
      }));
      setFormValues({
        schemeList: schemeList.filter((item) => {
          return (
            item.plan.toLowerCase() === "regular" && item.schemeValue !== "EB"
          );
        }),
      });
    } catch (e) {
      setFormValues({ schemeList: [] });
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchEuinList = async () => {
    try {
      setIsLoading(true);
      const response = await props.validateSubBroker({
        Fund: "189",
        SubAgentCd: "ARN-"+formValues["Sub ARN Code"].value || "",
        AgentCd: props.token,
      });
      const { DtData } = response;
      const euinList = DtData.map((item) => ({
        value: item.abm_name,
        label: item.abm_agent,
      }));
      setFormValues({ euinList: euinList });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchCategoryList = async () => {
    try {
      setIsLoading(true);
      let params = { plntype: REGULAR };
      params = { ...params, opt: "AT", fund: "189", customfund: "189" };
      const types = [
        GET_CATEGORY_LIST,
        GET_CATEGORY_LIST_SUCCESS,
        GET_CATEGORY_LIST_FAILED,
      ];
      const response = await props.getNewPurchaseFundList(params, types);
      const { Dtinformation } = response;
      const categoryList = Dtinformation.map((item) => ({
        value: item.fm_subcategory,
        label: item.fm_subcategory,
      }));
      setFormValues({ CategoryList: categoryList });
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchCategoryList();
  }, []);
  useEffect(() => {
    fetchSchemeList();
    fetchEuinList();
  }, [formValues.Category.value]);
  useEffect(() => {
    const handler= setTimeout(() => {
      if(!formValues["Sub ARN Code"].isError){
        fetchEuinList()
      }
    },1000)
    return ()=> clearTimeout(handler);
  },[formValues["Sub ARN Code"].value]); 
  const handleScheme = (label) => (event) => {
    const { schemeList } = formValues;
    if (label === "Scheme") {
      const scheme = schemeList.find((item) => item.value === event.value);
      setFormValues({
        Scheme: { value: event },
        "Scheme Plan": { value: scheme.plan },
        "Scheme Option": { value: scheme.option },
        planValue: scheme.planValue,
        optionValue: scheme.optionValue,
        schemeValue: scheme.schemeValue,
        minimumAmount: scheme.minAmt,
        multiples: scheme.multiples || 1,
      });
    }
    if (label === "EUIN") {
      setFormValues({
        EUIN: { value: event },
      });
    }
  };
  const handleChange = (label) => (event) => {
    const value = label !== "Scheme" ? event.target.value : event.value;
    switch (label) {
      case "Category":
        setFormValues({
          [label]: { value },
          Scheme: { value: "" },
          "Scheme Plan": "",
          "Scheme Option": "",
          Amount: { value: "" },
          EUIN: "",
        });
        break;
      case "Amount":
        if (parseInt(value) < parseInt(formValues.minimumAmount)) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                " Amount should be greater than or equal to " +
                formValues.minimumAmount,
            },
          });
        } else if (parseInt(value) % parseInt(formValues.multiples) !== 0) {
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                "Amount should be multiple of " + formValues.multiples,
            },
          });
        } else {
          setFormValues({ [label]: { value } });
        }
        break;
      case "Sub Broker Code":
        if(`ARN-${value}`===props.token){
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                "Sub Broker Code and ARN code should not be same",
            },
          });
        }
        else{
          setFormValues({ [label]: { value } });
        }
        break
      case "Sub ARN Code":
        if(`ARN-${formValues["Sub ARN Code"].value}`===props.token){ 
          setFormValues({
            [label]: {
              value,
              isError: true,
              errorMessage:
                "Sub ARN Code and ARN code should not be same",
            },
        })
      }
        else{
          setFormValues({ [label]: { value } });
      }
      break
        default:
        setFormValues({ [label]: { value } });
    }
  };
  const closeModel = () => {
    history.replace("/new-transaction");
  };
  const gotoTransactionTypes = () => {
    history.replace("/");
  };
  const dispatch = useDispatch();
  const submit = async () => {
    if (!formValues.Category.value) {
      setFormValues({
        Category: {
          value: "",
          isError: true,
          errorMessage: " Category is Mandatory",
        },
      });
      return;
    } else if (!formValues.Scheme.value) {
      setFormValues({
        Scheme: {
          value: "",
          isError: true,
          errorMessage: " Scheme is Mandatory",
        },
      });
      return;
    } else if (!formValues.EUIN.value) {
      setFormValues({
        EUIN: {
          value: "",
          isError: true,
          errorMessage: " EUIN is Mandatory",
        },
      });
      return;
    } else if (!formValues.Amount.value) {
      setFormValues({
        Amount: {
          value: "",
          isError: true,
          errorMessage: " Amount is Mandatory",
        },
      });
      return;
    } else if (!isChecked) {
      alert("Please accept the terms and conditions to proceed");
      return;
    } else if (formValues.Amount.value < formValues.minimumAmount) {
      setFormValues({
        Amount: {
          value: formValues.Amount.value,
          isError: true,
          errorMessage:
            " Amount should be greater than or equal to " +
            formValues.minimumAmount,
        },
      });
      return;
    } else if (formValues.Amount.value % formValues.multiples !== 0) {
      setFormValues({
        Amount: {
          value: formValues.Amount.value,
          isError: true,
          errorMessage:
            "Amount should be a multiple of " + formValues.multiples,
        },
      });
      return;
    }
    else if(`ARN-${formValues["Sub Broker Code"]?.value}`===props.token){
      setFormValues({
        "Sub Broker Code": {
          value: formValues["Sub Broker Code"].value,
          isError: true,
          errorMessage:
            "Sub Broker Code and ARN code should not be same",
        },
      });
      return;
    }
    else if(`ARN-${formValues["Sub ARN Code"].value}`===props.token){
      setFormValues({
        "Sub ARN Code": {
          value: formValues["Sub ARN Code"].value,
          isError: true,
          errorMessage:
            "Sub ARN Code and ARN code should not be same", 
        },
      });
      return;
    }
     else {
      setIsLoading(true);
      const response = await props.PurchaseSaveNominee({ ...props.nomineDetails.payload ? props.nomineDetails.payload : {} });
      if(!!response?.Dtinformation[0]?.nom_id || response?.Dtinformation[0]?.nom_id===null){
        const schemedetails = {
          IWishToNominate: props?.nomineDetails?.payload?.IWishToNominate,
          i_scheme: formValues.schemeValue,
          i_plan: formValues.planValue,
          i_option: formValues.optionValue,
          i_EUINno: formValues.EUIN.value.value,
          i_amount: formValues.Amount.value,
          i_disitributorid: props.token,
        };
        props.storeSchemeDetails({
          ...formValues,
          type: "lumpsum",
          ct: formValues.Category.value,
        });
        const paramsLumpsum = {
          ...props.applicantparams,
          ...props.fatcaDetails,
          ...props.investmentparams,
          ...schemedetails,
          ...props?.nomineDetails?.dotnetApiSubmitKeys,
          Nomslno: response.Dtinformation[0]?.nom_id || "",
          i_trtype: "NEW",
          i_appldt: format(new Date(), "MM/dd/yyyy"),
          i_chqdt: format(new Date(), "MM/dd/yyyy"),
          i_entby: props.userId,
          i_bankadd2: " -",
          i_bankadd3: " -",
          Invdistflag: "B",
          CustomFund: "189",
          i_fund: "189",
        };
        try{
          const responseLumpsum = await props.submitLumpsumDetails(paramsLumpsum);
          const { DtData } = responseLumpsum;
          const { appno } = DtData[0];
          dispatch(clearingFirstTimeInvestorJourney());
          setDialog({ appno: appno, open: true });
          setIsLoading(false);
        }
        catch(err){
          alert(err)
          setIsLoading(false)
        }
      }
      else{
        alert("Nominee ID is missing. Please check the nominee details.");
        setIsLoading(false);
      }

      
    }
  };
  return (
    <>
      <CustomLoader display={isLoading} />
      <CardComponent title="Scheme Details">
        <></>
        {InputFields.map((section, index) => (
          <div key={index}>
            {section.map((field) => (
              <div
                className="input-margin-investor-flow appbar-div dual-margin"
                key={field.name}
                style={{
                  display: field.display ? "none" : "",
                }}
              >
                {field.type === "select" ? (
                  <CustomizedSelect
                    name={field.name}
                    isMandatory={field.isMandatory}
                    value={formValues[field.name].value}
                    isError={formValues[field.name].isError}
                    errorMessage={formValues[field.name].errorMessage}
                    handleChange={handleChange(field.name)}
                    placeholder={`Select ${field.name}`}
                    id={`${field.name}Field`}
                    disabled={field.disabled}
                  >
                    {formValues[field.listName].map((i, index) => (
                      <MenuItem value={i.value} key={index}>
                        {i.label}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                ) : field.type === "Searchselect" ? (
                  <>
                    <div>
                      <div className="input-name input-integrated-label">
                        {field.name === "Scheme" ? "Scheme" : "EUIN Declaration"}
                      </div>
                      <IntegrationReactSelect
                        suggestions={formValues[field.listName].map((i) => ({
                          label: i.label,
                          value: i.value,
                        }))}
                        value={formValues[field.name].value}
                        placeholder={`Select ${field.name}`}
                        handleChange={handleScheme(field.name)}
                        disabled={field.disabled}
                        isError={formValues[field.name].isError}
                        errorMessage={formValues[field.name].errorMessage}
                      />
                    </div>
                    {field.name === "Amount" && (
                      <span>Minimum Amount : ₹ {formValues.minimumAmount}</span>
                    )}
                  </>
                ) : (
                  <>
                    <div>
                      <Input
                        name={field.name}
                        isMandatory={field.isMandatory}
                        type={field.type}
                        value={formValues[field.name].value}
                        onChange={handleChange(field.name)}
                        onBlur={handleChange(field.name)}
                        isError={formValues[field.name].isError}
                        isShowError={formValues[field.name].isError}
                        errorMessage={formValues[field.name].errorMessage}
                        id={`${field.name}Field`}
                        disabled={field.disabled}
                      />
                    </div>
                    {field.name === "Amount" && (
                      <span style={{ fontFamily: "Rubik-Regular" }}>Minimum Amount : ₹ {formValues.minimumAmount}</span>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        ))}
        <>
          <Checkbox
            onChange={() => setIsChecked((p) => !p)}
            checked={isChecked}
          />
          <span style={{ fontWeight: 500, fontFamily: "Rubik-Regular" }}>
            I/We have read and understood the contents of the Offer Document(s),
            Load Structure(s) of the respective Scheme(s) and agree to abide by
            the terms, conditions, rules and regulations of the respective
            Scheme(s).
          </span>
        </>
        <Termsandconditions />
      </CardComponent>
      <div className="d-flex justify-content-end">
        <button
          className="new-investor-button  new-investor-active"
          style={{ filter: "grayscale(1) opacity(0.4)" }}
          onClick={() =>
            history.replace("/new-investor-transaction/bank-details")
          }
        >
          BACK
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          SUBMIT
        </button>
        <CustomizedDialogs
          open={dialog.open}
          refNo={dialog.appno}
          transactName={"Lumpsum"}
          closeModal={gotoTransactionTypes}
          Transaction={true}
          transactionStatus={closeModel}
        />
      </div>
    </>
  );
};
export default connect(
  ({ authReducer, transactions, newinvestor }) => {
    const { token, userId } = authReducer;
    const { euinList } = transactions;
    const {
      schemeDetails,
      fatcaDetails,
      applicantparams,
      investmentparams,
      nomineDetails,
    } = newinvestor;
    return {
      schemeDetails,
      token,
      userId,
      euinList,
      fatcaDetails,
      applicantparams,
      investmentparams,
      nomineDetails,
    };
  },
  {
    getNewPurchaseFundList,
    validateSubBroker,
    submitLumpsumDetails,
    storeSchemeDetails,
    clearingFirstTimeInvestorJourney,
    PurchaseSaveNominee
  }
)(Lumpsum);
